import React, { useState } from 'react';
import { Box } from '@mui/material';
import { v2Theme } from '../design/theme';
import TopBar from './TopBar';
import BottomNav from './BottomNav';
import SideMenu from './SideMenu';
import V2Footer from './V2Footer';
import { isNative } from '../platform/capacitor';
import { useV2Common } from '../state/CommonProvider';
import FloatingWhatsAppButton from '../components/FloatingWhatsAppButton';

export default function AppShell({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isDesktop } = useV2Common();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        maxWidth: '100%',
        bgcolor: v2Theme.palette.background,
        overflowX: 'hidden',
      }}
    >
      <TopBar onOpenMenu={() => setMenuOpen(true)} />
      <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
      <Box
        component="main"
        sx={{
          maxWidth: isDesktop ? 1280 : '100%',
          mx: isDesktop ? 'auto' : 0,
          width: '100%',
          minWidth: 0,
          px: isDesktop ? 2 : 0,
          overflowX: 'hidden',
          boxSizing: 'border-box',
          pb:
            !isDesktop && isNative()
              ? 'calc(72px + env(safe-area-inset-bottom, 0px) + 8px)'
              : 0,
        }}
      >
        {children}
      </Box>
      {!isNative() ? <V2Footer /> : null}
      <FloatingWhatsAppButton />
      <BottomNav />
    </Box>
  );
}
